import { render } from "./FormComapnyComponent.vue?vue&type=template&id=c7829d74"
import script from "./FormComapnyComponent.vue?vue&type=script&lang=js"
export * from "./FormComapnyComponent.vue?vue&type=script&lang=js"

import "./FormComapnyComponent.vue?vue&type=style&index=0&id=c7829d74&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__